import { Controller } from "stimulus"

export default class extends Controller {
  static get values() {
    return { timeout: Number }
  }

  connect() {
    const timeout = this.timeoutValue || 4000
    this.timeout = setTimeout(() => this.dismiss(), timeout)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    if (!this.element) return

    this.element.classList.add("opacity-0", "translate-y-1", "transition", "duration-300")
    setTimeout(() => {
      if (this.element && this.element.parentNode) {
        this.element.parentNode.removeChild(this.element)
      }
    }, 2200)
  }
}
